import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './letter-template.action';

@Injectable({ providedIn: 'root' })
export class LetterTemplateTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                created_at: '',
                is_active: null,
                title: '', 
            };


    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'title';
    initialSortDirection = 'asc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    statuses = [
        {"id": "1", "name": "COMMON.active"},
        {"id": "0", "name": "COMMON.inactive"}
    ];

    columns = [
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date", widthSet: 180},
                { prop: 'title', name: 'LETTER_TEMPLATE.field-title', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'is_active', name: 'COMMON.status', sortable: true, hasFilter: true, filter: "select", options: 'statuses', options_id: "id", options_label: "name"},
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: ""},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            created_at: '',
            is_active: null,
            title: '', 
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}